import { collection, doc, getDoc, getDocs, setDoc, writeBatch } from 'firebase/firestore';
import { db } from '../firebaseClient';
import { PortfolioItem, CarouselItem, HeroConfig, Campaign } from '@shared/types';

export class FirestoreConfigProvider {
    
    // CAROUSEL
    async getCarouselItems(): Promise<CarouselItem[]> {
        const querySnapshot = await getDocs(collection(db, 'config_carousel'));
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as CarouselItem));
    }

    async saveCarouselItems(items: CarouselItem[]): Promise<void> {
        const batch = writeBatch(db);
        for (const item of items) {
            const docRef = doc(db, 'config_carousel', item.id);
            batch.set(docRef, item);
        }
        await batch.commit();
    }

    async saveCarouselItem(item: CarouselItem): Promise<void> {
        const docRef = doc(db, 'config_carousel', item.id);
        await setDoc(docRef, item);
    }

    // HERO CONFIG
    async getHeroConfig(): Promise<HeroConfig | null> {
        const docRef = doc(db, 'config_hero', 'main');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data() as HeroConfig;
        }
        return null;
    }

    async saveHeroConfig(config: HeroConfig): Promise<void> {
        const docRef = doc(db, 'config_hero', 'main');
        await setDoc(docRef, config);
    }

    // PORTFOLIO
    async getPortfolioItems(): Promise<PortfolioItem[]> {
        const querySnapshot = await getDocs(collection(db, 'config_portfolio'));
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as PortfolioItem));
    }

    async savePortfolioItems(items: PortfolioItem[]): Promise<void> {
        const batch = writeBatch(db);
        for (const item of items) {
            const docRef = doc(db, 'config_portfolio', item.id);
            batch.set(docRef, item);
        }
        await batch.commit();
    }

    // CAMPAIGNS
    async getCampaigns(): Promise<any[]> {
        const querySnapshot = await getDocs(collection(db, 'config_campaigns'));
        return querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as any));
    }

    async saveCampaigns(campaigns: Campaign[]): Promise<void> {
        const batch = writeBatch(db);
        for (const camp of campaigns) {
            const docRef = doc(db, 'config_campaigns', camp.id);
            batch.set(docRef, camp);
        }
        await batch.commit();
    }
}

export const firestoreConfigProvider = new FirestoreConfigProvider();
